import i18n from '@/plugins/i18n';
const performanceMONGOGraphs = () => ({
  lineCharts: [
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.maxReplicationsLag'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#fdfcac'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_mongodb_max_replication_lag',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.countPerMinute'),
      },
      show: true,
      showForSingleSeries: true,
      showmetricRate: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.numberOfOpenCursorsPerReplicaset'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_mongodb_no_of_open_cursor',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.countPerMinute'),
      },
      showLegendForSeries: true,
      showmetricRate: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.numberOfTimedOutCursorsPerReplicaset'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#fdfcac'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_mongodb_no_of_timed_out_cursor',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.countPerMinute'),
      },
      showLegendForSeries: true,
      showmetricRate: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.avgDurationOfBackgroundPerReplicaSets'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_mongodb_avg_duration_of_background',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.avgRatePerMinute'),
      },
      showLegendForSeries: true,
      showmetricRate: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.readRequests'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#fdfcac'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_mongodb_read_req_per_sec',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.countPerMinute'),
      },
      showLegendForSeries: true,
      showmetricRate: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.writeRequests'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_mongodb_write_req_per_sec',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.countPerMinute'),
      },
      showLegendForSeries: true,
      showmetricRate: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.mostUSedReplicaSetsForReads'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#fdfcac'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_mongodb_most_used_replicasets_for_reads',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.countPerMinute'),
      },
      showLegendForSeries: true,
      showmetricRate: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.mostUSedReplicaSetsForWrites'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_mongodb_most_used_replicasets_for_writes',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.countPerMinute'),
      },
      showLegendForSeries: true,
      showmetricRate: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.numberOfClientsWithReadIn-ProgrssOrQueued'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#fdfcac'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_mongodb_no_of_clients_with_read_inprogress_or_queued',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.countPerMinute'),
      },
      showLegendForSeries: true,
      showmetricRate: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.numberOfClientsWithWriteIn-ProgrssOrQueued'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_mongodb_no_of_clients_with_write_inprogress_or_queued',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.countPerMinute'),
      },
      showLegendForSeries: true,
      showmetricRate: true,
    },
  ],
});

export default performanceMONGOGraphs;
